'use client';

import type { ReactNode } from 'react';
import { AuthContextProvider } from '../AuthContext';
import type { AuthProviderProps } from '../types';
import { useElectronOpenIdAuth } from '../../../../hooks/useElectronOpenIdAuth';

const OpenIdAuthContextBridge = ({ children }: { children: ReactNode }) => {
  const { contextValue } = useElectronOpenIdAuth();

  return (
    <AuthContextProvider value={contextValue}>{children}</AuthContextProvider>
  );
};

export const OpenIdAuthProvider = ({ children }: AuthProviderProps) => {
  return <OpenIdAuthContextBridge>{children}</OpenIdAuthContextBridge>;
};
